module.exports = __webpack_public_path__ + "static/img/edmonton2.1c7fe86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/edmonton2.jpg
// module id = 82
// module chunks = 9